import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const AttachmentCircleIcon = createIcon({
  displayName: 'AttachmentCircleIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M11 13v0c1 1 2.6 1 3.5 0l1.6-1.6c.8-.8.8-2 0-2.8l-.7-.7c-.8-.8-2-.8-2.8 0v0" />
        <path d="M13 11v0c-1-1-2.6-1-3.5 0l-1.6 1.6c-.8.8-.8 2 0 2.8l.7.7c.8.8 2 .8 2.8 0v0" />
      </g>
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const AttachmentCircle: FC<IconProps> = (props) => {
  return <CustomIcon as={AttachmentCircleIcon} {...props} />
}

export default memo(AttachmentCircle)
